import { motion, AnimatePresence } from 'motion/react';
import useWindowSize from '@/utils/useWindowSize';
import { getOrderStatusTime } from '../active-orders/getOrderStatusTime';
import { ChipOrder } from '@/ui/Chip-Order';
import { cn } from '@/utils/merge';
import { PlatformLogo } from '@/ui/Platform-Logo';
import s from './draft-orders.module.css';
import { PAYMENT_TYPES } from '@/utils/constants';
import orderController from '@/services/OrderController';
import { ReadyButton } from './Ready-Button';
import { CancelButton } from './Cancel-Button';

const DraftOrders = ({
	mapVisible,
	data,
	showShop,
	onOpenClient,
	continuousOrderDisplayTime,
	onReady,
	onCancelDraftOrder,
}) => {
	const size = useWindowSize();
	const isSmall = size.width <= 920;

	return (
		<div
			className={showShop ? s.container : s.containerShop}
			style={!mapVisible ? { maxWidth: 2500 } : undefined}
		>
			{/* {data?.length > 0 ? (
				<div className='mb-2 text-lg font-semibold text-cyan-700!'>
					{data?.length} παραγγελί{data?.length === 1 ? 'α' : 'ες'}
				</div>
			) : (
				<div />
			)} */}
			<AnimatePresence>
				{data?.map?.((order, idx) => {
					const { orderStatusTime, preparationStatus } = getOrderStatusTime({
						order,
						continuousOrderDisplayTime,
					});

					const time = new Date(order?.createdAt).toLocaleTimeString([], {
						hour: '2-digit',
						minute: '2-digit',
						hour12: false,
					});

					return (
						// console.log("eee", order.price, order.price.length) ||
						<motion.div
							key={order.id}
							layout // <<< THIS DOES THE MAGIC
							initial={{ opacity: 0, y: 20 }}
							animate={{ opacity: 1, y: 0 }}
							exit={{
								opacity: 0,
								y: -20,
								backgroundColor: '#00ff00', // green flash
							}}
							transition={{ type: 'spring', stiffness: 240, damping: 20 }}
							// auto einai to glow:
							//  ${s[`orderRowGlow${orderStatusTime.className}`]}
							className={`${s.order} ${s.orderRowGlow} border-l-zinc-600 will-change-transform`}
						>
							<div className={cn(`${s.orderRow} pr-1`)}>
								<div
									className={cn(
										// 'mr-0.5 flex gap-y-1.5',
										// showShop ? 'flex flex-[0.83] flex-col' : 'flex-row items-center gap-x-2',
										'mr-0.5 flex flex-[0.83] flex-col gap-y-1.5',
										'min-[860px]:flex-[0.7]',
										'min-[1200px]:flex-[0.6]',
										'min-[1300px]:flex-[0.5]',
									)}
								>
									<div
										className={cn(`py-1 leading-4 font-semibold`, 'min-[1020px]:leading-5')}
										// onClick={() => showShop && orderClick(order)}
									>
										{showShop ? (
											order.shop?.name
										) : (
											<div className='flex flex-row gap-x-1'>
												{order.platform ? <PlatformLogo platform={order.platform} /> : null}
												{order?.platformHashOrderId || ''}
											</div>
										)}
									</div>
									{order?.price || order.distanceMeters || order.fee ? (
										<div className='mb-0.5 flex flex-row gap-x-1.5'>
											{order?.price ? <ChipOrder value={order?.price} variant='price' /> : null}
											{order?.tip ? <ChipOrder value={order?.tip} variant='tip' /> : null}
											{order.fee && showShop ? (
												<ChipOrder
													value={order.fee}
													variant='fee'
													isCard={order.paymentType === PAYMENT_TYPES.CARD}
												/>
											) : null}
											{order.distanceMeters ? (
												<ChipOrder
													value={(order.distanceMeters / 1000)?.toFixed(1)}
													// value={700 / 1000}
													variant='distance'
												/>
											) : null}
										</div>
									) : null}
								</div>

								<div
									className={cn(
										'ml-1 flex flex-[1] flex-col min-[900px]:flex-row min-[900px]:gap-x-2 min-[1020px]:flex-[1.2]',
										'min-[1400px]:flex-[1.4]',
										'max-[600px]:flex-[1.1]',
									)}
								>
									<div
										onClick={
											order.client?.id && showShop
												? () => onOpenClient(order.client, order.clientId)
												: undefined
										}
										className={cn(
											'min-[900px]:flex-[1.1]',
											'min-[1200px]:flex-[0.65]',
											'min-[1500px]:flex-[0.6]',
											// 'min-[1200px]:[flex-shrink:0]', // ← here, on the client div itself
											//
										)}
										style={{ cursor: order.client?.id && showShop ? 'pointer' : 'default' }}
									>
										{order?.client?.f}
									</div>

									<div
										className={cn(
											'flex min-w-0 flex-col',
											'min-[900px]:flex-1',
											'min-[1200px]:flex-[1.15]',
											//
										)}
									>
										{order.address?.s || order.address?.street ? (
											<div className='leading-4 font-semibold min-[900px]:leading-5'>
												{order.address?.s || order.address?.street}
											</div>
										) : null}

										{order.area ? <div className=''>{order.area}</div> : null}
									</div>
								</div>

								<div
									className={cn(
										'flex flex-[1] flex-col-reverse items-end',
										// 'min-[860px]:flex-row',
										'max-[700px]:flex-[0.87]',
										'min-[700px]:max-[860px]:flex-[0.7]',
										'min-[920px]:flex-[0.85]',
										'min-[860px]:justify-end min-[860px]:gap-x-2',
										'min-[1020px]:flex-col-reverse',
										'min-[1300px]:flex-[0.6]',
										'min-[1500px]:flex-[0.74] min-[1500px]:flex-row min-[1500px]:items-center',
									)}
								>
									<div className='flex flex-col gap-1 min-[1500px]:flex-row-reverse'>
										{!showShop && <ReadyButton order={order} cb={onReady} />}
										<CancelButton order={order} />
									</div>

									<div
										// onClick={() => showShop && orderClick(order)}
										className={`!bg-zinc-600 ${s.minutes} ${s[orderStatusTime.className]}`}
										style={{ marginBottom: 1 }}
									>
										{order.platformEstimatedTime}
									</div>
								</div>
							</div>

							{/* <div className='flex flex-row gap-x-2'>
								{order?.orderComments?.length > 0 && (
									<div className='font-regular! mt-0.5 mr-1 rounded-[4px] bg-pink-200! px-1.5 py-0.5 text-zinc-900!'>
										{order.orderComments}
									</div>
								)}
							</div> */}

							<div className='flex flex-row gap-x-2'>
								<div className='font-regular! mt-0.5 mr-1 rounded-[10px] bg-slate-400! px-2.5 py-0.5 text-zinc-100!'>
									{time}
								</div>
								{order?.addressComments?.length > 0 && (
									<div className='font-regular! mt-0.5 mr-1 rounded-[4px] bg-amber-200! px-1.5 py-0.5 text-zinc-900!'>
										{order.addressComments}
									</div>
								)}
								{order?.orderComments?.length > 0 && (
									<div className='font-regular! mt-0.5 mr-1 rounded-[4px] bg-pink-200! px-1.5 py-0.5 text-zinc-900!'>
										{order.orderComments}
									</div>
								)}
							</div>
						</motion.div>
					);
				})}
			</AnimatePresence>
		</div>
	);
};

export default DraftOrders;
